import React from 'react';
import SEO from "../common/SEO";
import Layout from "../common/Layout";
import BreadcrumbOne from "../elements/breadcrumb/BreadcrumbOne";
import { FiCheck } from "react-icons/fi";

import ContactOne from "../elements/contact/ContactOne";
import ScrollAnimation from "react-animate-on-scroll";


const MemAssociation = () => {
    return (
        <>
            <SEO title="Events" />
            <Layout>
                <BreadcrumbOne 
                    title="Membership For Associations"
                    rootUrl="/"
                    parentUrl="Home"
                    currentUrl="Membership For Associations"
                />
            <div className="row row--30 mt--30" style={{padding:"30px"}}>
            <div className="col-lg-6 col-md-5 col-sm-4 col-12 bg-color-white radius">
            <div className="split-inner" style={{padding:"30px"}}>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">UFTAA assists national associations in their contacts with associated authorities, globally. We welcome Associations who represent members involved with the following activities may apply for UFTAA membership. </p>
                            </ScrollAnimation>
                          
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                 <ul className="feature-list">
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Travel agencies</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> 	Tour operators (inbound and outbound)</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> Tours/Sightseeing operators</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">  	Tourism agencies involved with specialized services like sports; medical; wellness; adventure; wildlife/safaris</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description"> 	Companies in the business of hospitality</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">  	MICE/ Meetings/ Congresses/ Exhibition/ Event organizers</p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">  	Transport/coach companies; car/cab/limo companies;</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">   	Air Charter companies </p>
                                        </div>
                                    </li>

                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">  	 	Allied service providers including ".com or online companies" </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">   	Technology providers </p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">   	 	Education providers</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div className="title-wrapper">
                                            <p className="description">   	 	 	And associations who have members in any other related fields.</p>
                                        </div>
                                    </li>
                                </ul>
                            </ScrollAnimation>
                          
                        </div>
            </div>
            <div className="col-lg-6 col-md-5 col-sm-4 col-12 bg-color-white radius" style={{padding:"30px"}}>
            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                            <h5 style={{fontsize:"30px", fontWeight:"bold"}}>Annual Fees</h5>

                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                                <p className="description">Annual Membership fee for Association Members is in two classifications, based on their membership. (2 UFTAA ID Cards with our compliments - for President/Chairman — Secretary or any two nominees of the Applicant association). (An UFTAA ID Card with our compliments -for one nominee of the Applicant)</p>
                            </ScrollAnimation>
                            <ScrollAnimation 
                            animateIn="fadeInUp"
                            animateOut="fadeInOut"
                            animateOnce={true}>
                            <h6 style={{fontsize:"30px", fontWeight:"bold"}}>One-time admission fee of € 500</h6>
                            <h6 style={{fontsize:"30px", fontWeight:"bold"}}>Associations with less than 250 Members : € 900</h6>
                            <h6 style={{fontsize:"30px", fontWeight:"bold"}}>Associations with more than 250 Members : € 1800</h6>

                            </ScrollAnimation>
                            <iframe src="https://docs.google.com/forms/d/e/1FAIpQLScZe-jNXB2Nyo-yaUgKt0IARxSjhTC4XnE0JmbLiAgyKix0hA/viewform?embedded=true" width="640" height="1236" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe>
            </div>
            </div>
        </Layout>
        </>
    )
}
export default MemAssociation;